import React, {Component} from "react";
import {withNamespaces} from "react-i18next";
import {dashboardService} from "../../../../services/dashboard.service";
import {connect} from "react-redux";
import {Button} from "react-bootstrap";
import {toastr} from "react-redux-toastr";
import i18next from "i18next";

class WidgetMZMAPManagement extends Component {

    state = {
        driverIp: "10.50.30.20:8080",
        playersList: null
    }

    componentDidMount() {
        this.getDataFromDriver();
    }

    getDataFromDriver = () => {
        dashboardService.getAudioPlayersList(this.state.driverIp)
            .then(res => this.setState({playersList: res}))
            .catch(res => {
                console.error('auto player problem', res.toString())
            })
    }

    toggleMute = (playerId, value) => {
        const { t } = this.props;
        dashboardService.muteAudioPlayer(this.state.driverIp, playerId, value)
            .then(res => {
                this.getDataFromDriver();
                toastr.info(t('mzmap-title'), t('msg.mzmap-send'))
            })
            .catch(res => {
                console.error('auto player problem', res.toString())
            })
    }

    render() {
        const { t } = this.props;
        return (
            <div className="mt-2">
                { this.state.playersList?.length ? (
                    <div className="card">
                        <div className="card-header">
                            <div className="card-title d-flex w-100">
                                <div className="align-self-center justify-content-between w-100">
                                    <b><span className="card-title"> { t('mzmap-title') } </span></b>
                                </div>
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="list-group mx-2">
                                { this.state.playersList?.map((item, idx) => {
                                    return (
                                        <div className="list-group-item list-group-item-action" key={item.Id}>
                                            <div className="row">
                                                <div className="col-md-7 d-flex">
                                                    <div>
                                                        <span className="text-wrap font-weight-bold align-self-center" >{item.Name}</span>
                                                        <p><small>{item.CurrentTrack?.Title}</small></p>
                                                    </div>
                                                </div>
                                                <div className="col-md-5">
                                                    <div className="flex-wrap">
                                                        <Button variant="outline-danger"
                                                                active={item.Muted === true}
                                                                className="m-1"
                                                                onClick={() => this.toggleMute(item.Id, !item.Muted) }>
                                                            <i className="fas fa-volume-down"> </i> &nbsp;
                                                            <span> { t('mute') }</span>
                                                        </Button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="card">
                        <div className="card-header"><span className="card-title"> {t('list-device-group')} </span></div>
                        <div className="card-body">
                            <div className="text-center p-4">
                                <h3>{ t('mzmap-no-content') }</h3>
                            </div>
                        </div>
                    </div>
                ) }
            </div>
        )
    }
}
const mapStateToProps = state => {
    const {user} = state.authenticationReducer;
    return {
        user
    }
};
export default withNamespaces()(connect(mapStateToProps)(WidgetMZMAPManagement));